<script lang="ts">
	import type { PageData, Snapshot } from './$types';

	const { data }: { data: PageData } = $props();

	let captureSnapshot = $state(() => {});
	// eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
	let restoreSnapshot = $state((value: any) => {});

	export const snapshot: Snapshot = {
		capture: () => captureSnapshot(),
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		restore: (value: any) => restoreSnapshot(value),
	};
</script>

{/* @ts-expect-error: ts error due to dynamic pageData types */ null}
<data.component data={data.pageData} store={data.store} bind:captureSnapshot bind:restoreSnapshot />
